import { useFormSchema } from "src/api/hooks/useFormSchema";

export const EmailWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`email-container container`}>
      <input
        type="email"
        className={`input-email`}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        required={required}
      />
    </div>
  );
};
